import { render, staticRenderFns } from "./StorePicker.vue?vue&type=template&id=08fa3f12&"
import script from "./StorePicker.vue?vue&type=script&lang=js&"
export * from "./StorePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports